import { useRouteMatch } from 'react-router-dom';
import { ROUTER_ENTITY_TO_ROUTE_PATH_MAP } from '../../../../constants';

type AQISensorParams = {
  sensorId?: string;
};

export const useSelectedAQISensorId = (): number | undefined => {
  // Using `useRouteMatch()` instead of `useParams()` since we're not always inside the AQI Sensor <Router>
  const match = useRouteMatch<AQISensorParams>(
    ROUTER_ENTITY_TO_ROUTE_PATH_MAP.aqi,
  );
  const sensorIdStr = match?.params.sensorId;

  return sensorIdStr ? parseInt(sensorIdStr, 10) : undefined;
};
